// Reconstructed from the supplied production build; original component names were unavailable.
import {
  ArrowLeftIcon,
  BookOpenIcon,
  FileTextIcon,
  Helmet,
  MailIcon,
  ScaleIcon,
  ShieldIcon,
  TriangleAlertIcon,
  UsersIcon,
  motion,
  useNavigate,
} from "../vendor/runtime.js";
const TermsPage = () => {
  const a = useNavigate(),
    n = () => {
      a(-1);
    },
    i = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.5,
        },
      },
    },
    l = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
        },
      },
    },
    c = [
      {
        id: 1,
        icon: UsersIcon,
        title: "Eligibility",
        content:
          "You must be at least 16 years old, or have the consent of a parent or guardian, to use CodeBruh. By using this site, you confirm that you meet this requirement.",
        color: "from-blue-500 to-cyan-500",
      },
      {
        id: 2,
        icon: TriangleAlertIcon,
        title: "No Refund Policy",
        content:
          "All sales are final. Once a project is purchased, we do not offer any refunds, cancellations, or exchanges under any circumstances. Please review all project details and demos before purchase.",
        color: "from-red-500 to-pink-500",
      },
      {
        id: 3,
        icon: ScaleIcon,
        title: "Licensing and Ownership",
        content:
          "All projects are either open-source, contributed by verified agents, or shared with a license for educational and non-commercial use only. You are responsible for reviewing any applicable third-party licenses.",
        color: "from-purple-500 to-indigo-500",
      },
      {
        id: 4,
        icon: BookOpenIcon,
        title: "Academic Integrity",
        content:
          "Projects sold on CodeBruh are intended for learning and reference. You are responsible for complying with your institution's academic policies. Misuse for plagiarism or misrepresentation is your own liability.",
        color: "from-green-500 to-emerald-500",
      },
      {
        id: 5,
        icon: ShieldIcon,
        title: "Limitation of Liability",
        content:
          "We do not guarantee grades, approvals, or academic outcomes. We are not liable for any misuse, misrepresentation, or loss resulting from use of our platform.",
        color: "from-orange-500 to-amber-500",
      },
      {
        id: 6,
        icon: FileTextIcon,
        title: "Changes to Terms",
        content:
          "We reserve the right to update or modify these Terms at any time. Continued use of the platform indicates your acceptance of the updated Terms.",
        color: "from-teal-500 to-cyan-500",
      },
    ];
  return (
    <div className={"min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100"}>
      <Helmet>
        <title>{"Terms of Service | CodeBruh"}</title>
        <meta
          name={"description"}
          content={
            "Read CodeBruh's Terms of Service. Understand our no-refund policy, licensing, and your responsibilities before buying final year projects."
          }
        />
      </Helmet>
      <section
        className={
          "bg-gradient-to-r from-slate-900 via-slate-800 to-indigo-900 relative overflow-hidden py-12 lg:py-16"
        }
      >
        <div className={"absolute inset-0 opacity-10"}>
          <div
            className={
              "absolute top-0 left-0 w-full h-full bg-gradient-to-br from-cyan-400/20 via-blue-500/20 to-purple-600/20"
            }
          />
          <div
            className={
              "absolute top-1/4 left-1/4 w-32 h-32 lg:w-48 lg:h-48 bg-white/5 rounded-full blur-3xl animate-pulse"
            }
          />
          <div
            className={
              "absolute bottom-1/4 right-1/4 w-24 h-24 lg:w-36 lg:h-36 bg-indigo-400/10 rounded-full blur-2xl animate-pulse delay-1000"
            }
          />
        </div>
        <div className={"relative mx-auto px-4"}>
          <motion.div
            initial={{
              opacity: 0,
              x: -20,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              duration: 0.5,
            }}
            className={"mb-6 lg:mb-8"}
          >
            <button
              onClick={n}
              className={
                "group inline-flex items-center px-3 sm:px-4 lg:px-6 py-2 lg:py-3 bg-white/10 backdrop-blur-sm border border-white/20 text-white rounded-lg lg:rounded-xl hover:bg-white/20 transition-all duration-300 text-xs sm:text-sm lg:text-base font-medium shadow-lg hover:shadow-xl"
              }
            >
              <ArrowLeftIcon
                className={
                  "w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5 mr-1.5 sm:mr-2 group-hover:-translate-x-1 transition-transform duration-300"
                }
              />
              {"Go Back"}
            </button>
          </motion.div>
          <div className={"text-center"}>
            <motion.div
              initial={"hidden"}
              animate={"visible"}
              variants={i}
              className={"text-white"}
            >
              <div
                className={
                  "w-12 h-12 sm:w-14 sm:h-14 lg:w-20 lg:h-20 mx-auto mb-4 lg:mb-6 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl lg:rounded-2xl flex items-center justify-center shadow-2xl"
                }
              >
                <FileTextIcon className={"w-6 h-6 sm:w-7 sm:h-7 lg:w-10 lg:h-10 text-white"} />
              </div>
              <h1
                className={
                  "text-xl sm:text-2xl lg:text-4xl font-bold mb-3 lg:mb-4 bg-gradient-to-r from-white to-slate-200 bg-clip-text text-transparent"
                }
              >
                {"Terms of Service"}
              </h1>
              <p
                className={
                  "text-sm sm:text-base lg:text-xl text-slate-300  mx-auto leading-relaxed"
                }
              >
                {
                  "Please read these terms carefully before using CodeBruh platform and purchasing any projects."
                }
              </p>
            </motion.div>
          </div>
        </div>
      </section>
      <main
        className={
          " mx-auto px-3 sm:px-4 py-6 sm:py-8 lg:py-12 -mt-6 sm:-mt-8 lg:-mt-12 relative z-10"
        }
      >
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={l}
          className={"space-y-4 sm:space-y-6 lg:space-y-8"}
        >
          {c.map((u, m) => (
            <motion.div
              key={u.id}
              variants={i}
              className={
                "bg-white rounded-xl lg:rounded-2xl shadow-xl border border-slate-100 overflow-hidden group hover:shadow-2xl transition-all duration-300"
              }
            >
              <div className={"p-6 lg:p-8"}>
                <div className={"flex items-start gap-4 lg:gap-6"}>
                  <div
                    className={`w-12 h-12 lg:w-14 lg:h-14 bg-gradient-to-br ${u.color} rounded-xl flex items-center justify-center shadow-lg flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}
                  >
                    <u.icon className={"w-6 h-6 lg:w-7 lg:h-7 text-white"} />
                  </div>
                  <div className={"flex-1"}>
                    <div className={"flex items-center gap-3 mb-3 lg:mb-4"}>
                      <span
                        className={
                          "text-xs lg:text-sm font-bold text-slate-500 bg-slate-100 px-2 py-1 rounded-full"
                        }
                      >
                        {"Section "}
                        {u.id}
                      </span>
                      <div
                        className={
                          "w-1 h-4 lg:h-5 bg-gradient-to-b from-indigo-500 to-purple-500 rounded-full"
                        }
                      />
                    </div>
                    <h2 className={"text-lg lg:text-xl font-bold text-slate-900 mb-3 lg:mb-4"}>
                      {u.title}
                    </h2>
                    <p className={"text-sm lg:text-base text-slate-600 leading-relaxed"}>
                      {u.content}
                    </p>
                  </div>
                </div>
              </div>
              <div className={`h-1 bg-gradient-to-r ${u.color}`} />
            </motion.div>
          ))}
          <motion.div
            variants={i}
            className={
              "bg-gradient-to-br from-indigo-50 to-purple-50 rounded-lg sm:rounded-xl lg:rounded-2xl border-2 border-indigo-200 p-4 sm:p-6 lg:p-8 text-center"
            }
          >
            <div
              className={
                "w-10 h-10 sm:w-12 sm:h-12 lg:w-16 lg:h-16 mx-auto mb-3 sm:mb-4 lg:mb-6 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg"
              }
            >
              <MailIcon className={"w-5 h-5 sm:w-6 sm:h-6 lg:w-8 lg:h-8 text-white"} />
            </div>
            <h3 className={"text-base sm:text-lg lg:text-xl font-bold text-slate-900 mb-2 lg:mb-3"}>
              {"Have Questions?"}
            </h3>
            <p
              className={
                "text-xs sm:text-sm lg:text-base text-slate-600 mb-3 sm:mb-4 lg:mb-6 text-justify mx-auto"
              }
            >
              {
                "If you have any questions about these Terms of Service, please don't hesitate to contact our support team."
              }
            </p>
            <a
              href={"mailto:codebruh@kestroinfotech.com"}
              className={
                "inline-flex items-center px-4 sm:px-6 lg:px-8 py-2 sm:py-3 lg:py-4 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold rounded-lg lg:rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-xs sm:text-sm lg:text-base"
              }
            >
              <MailIcon className={"w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5 mr-1.5 sm:mr-2"} />
              {"codebruh@kestroinfotech.com"}
            </a>
          </motion.div>
          <motion.div variants={i} className={"text-center py-6 lg:py-8"}>
            <div
              className={
                "inline-flex items-center px-4 lg:px-6 py-2 lg:py-3 bg-slate-100 rounded-full"
              }
            >
              <div className={"w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse"} />
              <span className={"text-xs lg:text-sm text-slate-600 font-medium"}>
                {"Last updated: January 2025"}
              </span>
            </div>
          </motion.div>
        </motion.div>
      </main>
    </div>
  );
};
export { TermsPage };
